import { ReactElement } from 'react';
import { useFlowNames } from '../hooks/flows';
import './FlowIdsPicker.scss';

export type FlowIdsPickerProps = {
  name: string;
  value?: string[];
  onChange: (flowIds: string[]) => void;
  disabled?: boolean;
};

/**
 * Pick some of the user's flows, or all of them, for a token permission
 */
export function FlowIdsPicker({
  name,
  value = [],
  onChange,
  disabled = false,
}: FlowIdsPickerProps): ReactElement {
  const names = useFlowNames(!disabled);
  const all = value.includes('*');

  // Ids that are no longer flows (deleted since) stay, so they can be removed
  const ids = [
    ...Object.keys(names),
    ...value.filter(id => id !== '*' && !(id in names)),
  ];

  const toggle = (id: string, checked: boolean) =>
    onChange(
      checked
        ? [...value.filter(v => v !== id), id]
        : value.filter(v => v !== id)
    );

  return (
    <div className="flow-ids-picker" id={name}>
      <label>
        <input
          type="checkbox"
          name={name}
          checked={all}
          disabled={disabled}
          onChange={e => onChange(e.target.checked ? ['*'] : [])}
        />
        All flows
      </label>
      {ids.map(id => (
        <label key={id}>
          <input
            type="checkbox"
            name={name}
            checked={all || value.includes(id)}
            disabled={disabled || all}
            onChange={e => toggle(id, e.target.checked)}
          />
          {names[id] ?? <code>{id}</code>}
        </label>
      ))}
      {!disabled && ids.length === 0 && (
        <span className="extra">You don't have any flows yet.</span>
      )}
    </div>
  );
}
